import loadable from "@loadable/component";

import { Loading, ErrorBoundary } from "../components";
import { Props, loadData } from "./DocsList";

const DocsList = loadable(() => import("./DocsList"), {
  fallback: <Loading />
});

export default (props: Props): JSX.Element => (
  <ErrorBoundary>
    <DocsList {...props} />
  </ErrorBoundary>
);
export { loadData };
